/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdmissionStatusInfo
 */
export interface AdmissionStatusInfo {
    /**
     * 
     */
    actioned_by?: string;
    /**
     * 
     */
    action_effective_date?: string;
    /**
     * 
     */
    scheduled_action_effective_date?: string;
    /**
     * 
     */
    comment?: string;
}

/**
 * Check if a given object implements the AdmissionStatusInfo interface.
 */
export function instanceOfAdmissionStatusInfo(value: object): value is AdmissionStatusInfo {
    return true;
}

export function AdmissionStatusInfoFromJSON(json: any): AdmissionStatusInfo {
    return AdmissionStatusInfoFromJSONTyped(json, false);
}

export function AdmissionStatusInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionStatusInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'actioned_by': json['actioned_by'] == null ? undefined : json['actioned_by'],
        'action_effective_date': json['action_effective_date'] == null ? undefined : json['action_effective_date'],
        'scheduled_action_effective_date': json['scheduled_action_effective_date'] == null ? undefined : json['scheduled_action_effective_date'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function AdmissionStatusInfoToJSON(json: any): AdmissionStatusInfo {
    return AdmissionStatusInfoToJSONTyped(json, false);
}

export function AdmissionStatusInfoToJSONTyped(value?: AdmissionStatusInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actioned_by': value['actioned_by'],
        'action_effective_date': value['action_effective_date'],
        'scheduled_action_effective_date': value['scheduled_action_effective_date'],
        'comment': value['comment'],
    };
}

